/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrderLinesDTO
 */
export interface CreateOrderLinesDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLinesDTO
     */
    itemCode: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderLinesDTO
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLinesDTO
     */
    freeText?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLinesDTO
     */
    profitCode: string;
}

/**
 * Check if a given object implements the CreateOrderLinesDTO interface.
 */
export function instanceOfCreateOrderLinesDTO(value: object): value is CreateOrderLinesDTO {
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('profitCode' in value) || value['profitCode'] === undefined) return false;
    return true;
}

export function CreateOrderLinesDTOFromJSON(json: any): CreateOrderLinesDTO {
    return CreateOrderLinesDTOFromJSONTyped(json, false);
}

export function CreateOrderLinesDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderLinesDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'itemCode': json['itemCode'],
        'quantity': json['quantity'],
        'freeText': json['freeText'] == null ? undefined : json['freeText'],
        'profitCode': json['profitCode'],
    };
}

export function CreateOrderLinesDTOToJSON(json: any): CreateOrderLinesDTO {
    return CreateOrderLinesDTOToJSONTyped(json, false);
}

export function CreateOrderLinesDTOToJSONTyped(value?: CreateOrderLinesDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itemCode': value['itemCode'],
        'quantity': value['quantity'],
        'freeText': value['freeText'],
        'profitCode': value['profitCode'],
    };
}

